import { apiClient, getActivePvzId, isSupabaseConfigured } from './_shared.js'

// ============================================
// ANALYTICS SETTINGS & FIXED EXPENSES
// ============================================

export async function getAnalyticsSettings(pvzId) {
  const targetId = pvzId || getActivePvzId()
  if (!targetId) return { expected_wb_payments_per_month: 4 }
  
  try {
    const data = await apiClient('/analytics/settings?pvzId=' + targetId)
    return data || { expected_wb_payments_per_month: 4 }
  } catch (err) {
    return { expected_wb_payments_per_month: 4 }
  }
}

export async function updateAnalyticsSettings(pvzId, settings) {
  if (!isSupabaseConfigured) return null
  const targetId = pvzId || getActivePvzId()
  return await apiClient('/analytics/settings', {
    method: 'POST',
    body: JSON.stringify({ ...settings, pvz_id: targetId })
  })
}

export async function getFixedExpenseTemplates(pvzId) {
  if (!isSupabaseConfigured) return []
  const targetId = pvzId || getActivePvzId()
  return await apiClient('/analytics/fixed-templates?pvzId=' + targetId)
}

export async function addFixedExpenseTemplate(pvzId, templateData) {
  if (!isSupabaseConfigured) return null
  const targetId = pvzId || getActivePvzId()
  return await apiClient('/analytics/fixed-templates', {
    method: 'POST',
    body: JSON.stringify({ ...templateData, pvz_id: targetId })
  })
}

export async function updateFixedExpenseTemplate(id, templateData) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/analytics/fixed-templates/${id}`, {
    method: 'PUT',
    body: JSON.stringify(templateData)
  })
}

export async function deleteFixedExpenseTemplate(id) {
  if (!isSupabaseConfigured) return
  return await apiClient(`/analytics/fixed-templates/${id}`, { method: 'DELETE' })
}

// RESERVES API
export async function getReserves(pvzId, startDate, endDate) {
  if (!isSupabaseConfigured) return []
  const params = new URLSearchParams()
  if (pvzId) params.append('pvzId', pvzId)
  if (startDate) params.append('startDate', startDate)
  if (endDate) params.append('endDate', endDate)
  return await apiClient('/analytics/reserves?' + params.toString())
}

export async function addReserve(pvzId, reserveData) {
  if (!isSupabaseConfigured) return null
  return await apiClient('/analytics/reserves', {
    method: 'POST',
    body: JSON.stringify({ ...reserveData, pvz_id: pvzId })
  })
}

export async function deleteReserve(id) {
  if (!isSupabaseConfigured) return true
  await apiClient(`/analytics/reserves/${id}`, { method: 'DELETE' })
  return true
}

// PARTNERS API
export async function getPartners(pvzId) {
  if (!isSupabaseConfigured) return []
  return await apiClient('/analytics/partners?pvzId=' + pvzId)
}

export async function addPartner(pvzId, data) {
  if (!isSupabaseConfigured) return null
  return await apiClient('/analytics/partners', {
    method: 'POST',
    body: JSON.stringify({ ...data, pvz_id: pvzId })
  })
}

export async function updatePartner(id, data) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/analytics/partners/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

export async function deletePartner(id) {
  if (!isSupabaseConfigured) return true
  await apiClient(`/analytics/partners/${id}`, { method: 'DELETE' })
  return true
}

export async function getPartnerTurnovers(pvzId, startDate, endDate) {
  if (!isSupabaseConfigured) return []
  const params = new URLSearchParams({ pvzId })
  if (startDate) params.append('startDate', startDate)
  if (endDate) params.append('endDate', endDate)
  return await apiClient('/analytics/partner-turnovers?' + params.toString())
}

export async function addPartnerTurnover(pvzId, data) {
  if (!isSupabaseConfigured) return null
  return await apiClient('/analytics/partner-turnovers', {
    method: 'POST',
    body: JSON.stringify({ ...data, pvz_id: pvzId })
  })
}

export async function updatePartnerTurnover(id, data) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/analytics/partner-turnovers/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

export async function deletePartnerTurnover(id) {
  if (!isSupabaseConfigured) return true
  await apiClient(`/analytics/partner-turnovers/${id}`, { method: 'DELETE' })
  return true
}
